<template>
  <div v-if="isAdmin" class="mixer-db-layout">
    <main class="mixer-db-content">
      <router-view />
    </main>
  </div>
  <div v-else>Access denied.</div>
</template>

<script>
export default {
  name: 'MixerDbIndex'
}
</script>
